<template>
  <div>
    <!-- toasts message -->
       <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <v-progress-circular v-if="Loader" :size="70" :width="7" color="teal" indeterminate></v-progress-circular>

    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card-text class="pb-0">
        <v-container grid-list-md class="pb-0">
          <v-layout wrap>

              <v-flex xs12 sm4 md6>
                 <v-text-field label="Package No" v-model="formSchema.package_no" :rules="[v => !!v || 'Field is required']" required readonly></v-text-field>
              </v-flex>

              <v-flex xs12 sm4 md6>
                 <v-select
                label="Procurement Method"
                item-text="name"
                item-value="id"            
                v-model="formSchema.method_id"
                :items="method_list"
                :rules="[v => !!v || 'Field is required']"
                required
                readonly
                ></v-select>
              </v-flex>

							<v-flex xs12 sm4 md6>
								 <v-text-field label="Package Name" v-model="formSchema.name" :rules="[v => !!v || 'Field is required']" required readonly></v-text-field>
							</v-flex>

              <v-flex xs12 sm4 md6>
                 <v-select
                  label="Package Status"
                  item-text="name"
                  item-value="id"
                  v-model="formSchema.status_id"
                  :items="status_list"
                  :rules="[v => !!v || 'Field is required']"
                  required
                ></v-select>
              </v-flex>

            

              <v-flex xs12 sm4 md6>
                 <v-select
                label="Procurement Type"
                item-text="name"
                item-value="id"            
                v-model="formSchema.procurement_type_id"
                :items="procurement_type_list"
                :rules="[v => !!v || 'Field is required']"
                required
                readonly
                ></v-select>
              </v-flex>

              <v-flex xs12 sm4 md6>
                <DatePicker
                :key="formSchema.id"
                :inputData="{index:4,fieldName:'from_date', fieldValue:formSchema.from_date, label:'Work Start Date'}"
                @setValue="setDateValue"
              ></DatePicker>
      
              </v-flex>
              <v-flex xs12 sm4 md6>
                <DatePicker
                :key="formSchema.id"
                :inputData="{index:6,fieldName:'revision_date', fieldValue:formSchema.revision_date, label:'Revision Date'}"
                @setValue="setDateValue"
                ref="setRangeRev"
              ></DatePicker>
              </v-flex>

              <v-flex xs12 sm4 md6>
                <DatePicker
                :key="formSchema.id"
                :inputData="{index:5,fieldName:'to_date', fieldValue:formSchema.to_date, label:'Contract End Date'}"
                @setValue="setDateValue"
                ref="setRange"
              ></DatePicker>
            
              </v-flex>
              <v-flex xs12 sm4 md6>
                
                 <v-text-field label="Estimated Price" v-model="formSchema.estimated_price" :rules="[v => !!v || 'Field is required']" required></v-text-field>
              </v-flex>

              <v-flex xs12 sm4 md6>
                 <v-text-field label="Quantity" v-model="formSchema.quantity" :rules="[v => !!v || 'Field is required']" required></v-text-field>
              </v-flex>

              <v-flex xs12 sm4 md6>
                 <v-text-field label="Meeting No" v-model="formSchema.meeting_no" :rules="[rules.isRequired]"></v-text-field>
              </v-flex>

             

              <v-flex xs12 sm4 md6>
                 <v-select
                label="contract_type"
                item-text="name"
                item-value="id"            
                v-model="formSchema.contract_type"
                :items="contract_type_list"
                :rules="[v => !!v || 'Field is required']"
                required
                ></v-select>
              </v-flex>
              
              <v-flex xs12 sm4 md12>
								 <v-text-field label="Remarks" v-model="formSchema.remarks" required></v-text-field>
							</v-flex>

						</v-layout>

        </v-container>
      </v-card-text>
    </v-form>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="submitPackageDetail">
        Save & Next
        <v-icon>arrow_forward_ios</v-icon>
      </v-btn>
      <v-btn color="secondary" @click="close">
        Reset
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-card-actions>
  </div>
</template>


<script>
const commonService = require('../../../../services/common.service');
import DatePicker from "../../../global/date_picker";

export default {
  components: {
    DatePicker
  },
    data: () => ({
      valid: true,
      e1: 0,
      show: false,
      Loader: false,

      unit_list:[],
      method_list:[],
      procurement_type_list:[],
      contract_type_list:[],
      status_list:[
        
        {id:'1',name: 'Plan'},
        {id:'3',name: 'Revision'},
        {id:'4',name: 'Merge'},
        {id:'5',name: 'Split'},
        {id:'9',name: 'Active'},
  

      ],

      snackbar: false,
      color: "success",
      mode: "",
      timeout: 3000,
      left: "left",
      message: "",
      package_info_id: sessionStorage.getItem("package_info"),
      formSchema:{
        id:'',
        package_no:'',
        method_id:'',
        name:'',
        status_id:'',
        revision_date:'',
        from_date:'',
        to_date:'',
        procurement_type_id:'',
        quantity:'',
        meeting_no:'',
        estimated_price:'',
        contract_type:'',
        remarks:''
      },
        SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
    }, 
    rules:{
      isRequired: (v) => {
    
        if (v && v.length > 0) {
          return (
            /[a-zA-Z0-9]*$/.test(
              v
            ) || "Meeting no. must be valid"
          );
        } else {
          return true;
        }
      },
    }      
    }),

    // computed: {
    //   formTitle () {
    //     return this.formSchema.id > 0 ? 'Update Procurement Packages' : 'New Procurement Packages'
    //   },
    // },

    created () {
     if(this.package_info_id)   
      {
      this.loadData();
      }  
      commonService.getAllData('proc_methods_list').then( res => { 
      
        this.method_list = res.data;
                     
      });
      commonService.getAllData('proc_unit_list').then( res => { 
     
        this.unit_list = res.data;
                    
      });
      commonService.getAllData('proc_types').then( res => { 
      
        this.procurement_type_list = res.data;
                     
      });
      commonService.getAllData('proc_contract').then( res => { 
     
        this.contract_type_list = res.data;
     
      });
    },
   
    methods: {
    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;
      if(data.fieldName == "from_date"){
        this.formSchema.to_date = 0
        this.formSchema.revision_date = 0
        this.$refs.setRange.setRange(data.value);
        this.$refs.setRangeRev.setRange(data.value);
      }
      if(data.fieldName == "revision_date"){
        this.formSchema.to_date = 0
        this.$refs.setRange.setRange(data.value);
      }
    },
    loadData() {
      let formSchema = this.formSchema;
      commonService
        .getAllDataById(this.package_info_id, "proc_revision")
        .then(res => {
          if (res.data) {
            this.formSchema = res.data;

            this.formSchema.from_date = this.changeFormateDMY(
              res.data.from_date
            );
            this.formSchema.to_date = this.changeFormateDMY(
              res.data.to_date
            );
            this.formSchema.revision_date = this.changeFormateDMY(
              res.data.revision_date
            );
            this.formSchema.contract_type = parseInt(res.data.contract_type)

            console.log("this.formSchema = ", this.formSchema);
          }
          this.show = true;
        });
    },

    submitPackageDetail() {
      //this.nextStep();
      
      let root = this;
      this.Loader = true;
      let formSchema = this.formSchema;

      formSchema.from_date = root.changeFormateYMD(
        this.formSchema.from_date
      );
      formSchema.to_date = root.changeFormateYMD(
        this.formSchema.to_date
      );
      formSchema.revision_date = root.changeFormateYMD(
        this.formSchema.revision_date
      );
      

      commonService.updateFormData(formSchema, 'proc_packages').then(res => {							
							if(res.status == 1){
                 this.Loader = true;
                  this.SnackbarVal.color = "success";
      this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
                setTimeout(function() {
                  root.nextStep();
                }, 3000); 
							}
						});
      
    },

    nextStep() {
      this.Loader = false;
      this.$emit("emitForm1", 2);
    },

    previous() {
      this.$emit("emitForm1", 1);
    },

    close: function() {
      this.$refs.form.reset();
    }
  }
};
</script>
<style scoped>
.v-progress-circular {
  margin: 10rem;
  position: absolute !important;
  left: 37%;
}
</style>



// WEBPACK FOOTER //
// src/components/procurement/package_revision/step_forms/RevisionEntry.vue